import { render } from "./VAbout.vue?vue&type=template&id=2d6e9c51"
import script from "./VAbout.vue?vue&type=script&lang=ts"
export * from "./VAbout.vue?vue&type=script&lang=ts"

import "./VAbout.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script